import { useSelectedPaymentInformation } from "@apac/checkout";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CardTypeCollection } from "@hopper-b2b/types";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface PaymentMethodProps {
  displayName?: string;
  className?: string;
}

export const PaymentMethod = ({
  displayName,
  className,
}: PaymentMethodProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PaymentMethod");
  const selectedPayment = useSelectedPaymentInformation();
  const cardName =
    displayName ?? CardTypeCollection[selectedPayment?.cardType ?? ""];

  if (!selectedPayment) {
    return null;
  }

  return (
    <div className={clsx(block, className ?? "")}>
      <div className={cn("label")}>{t("paymentMethod")}</div>
      <div className={cn("card")}>
        <span className={cn("card-name")}>{cardName}</span>
        <span
          className={cn("card-number")}
        >{`(${selectedPayment.last4})`}</span>
      </div>
    </div>
  );
};
